<template>
  <div class="commentairesListe encart">
    <h2>Commentaire de l'article</h2>
    <div v-if="filteredCommentaires.length > 0">
      <div v-for="(commentaire, index) in filteredCommentaires" :key="index" class="commentaire">
        <h3>Commentaire de l'article</h3>
        <p>{{ commentaire.commentaire }}</p>
        <p class="sign">Mis à jour le {{ commentaire.date }} par {{ commentaire.utilisateur }}</p>
      </div>
    </div>
    <div v-else>
      <p>Aucun commentaire disponible.</p>
    </div>
  </div>
</template>


<script>
import axios from '@/components/axiosConfig.js'



export default {
  data() {
    return {
      commentaires: [],
      codeArticle: '',
    }
  },
  created() {
    this.codeArticle = this.$route.params.codeArticle;
  },
  mounted() { 
    
    // Récupération des commentaires
    axios.post('https://www.simef.fr/espace-client/api/getCommentaire.php', {
      codeArticle: this.codeArticle
    })
    .then(response => {
        this.commentaires = response.data;
    })
    .catch(error => {
        console.log(error);
        
    });

  }, 
  computed: {
    filteredCommentaires() {
      return this.commentaires.filter(commentaire => commentaire.commentaire !== '');
    },
  },
  methods: {
  
  }

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $primary: #2b358d;
  h2 {
    text-align: left;
    margin-bottom: 15px;
  }
  h3 {
    font-size: 1.2rem!important;
    text-transform: none!important;
    font-weight: 600;
  }
  .sign {
    font-size: 0.85rem;
    font-style: italic;
    font-weight: 600;
    color: $primary;
  }

</style>
